import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';


export const DatePicker = ({ 
  label,
  error,
  helperText,
  required,
  layout,
  labelCol,
  wrapperCol,
  ...props 
}) => {
  if(props.value) {
    props.value = dayjs(props.value)
  }
  return (
    <InputWrapper
      label={label}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <AntDatePicker 
        status={error ? 'error' : ''} 
        style={{ width: '100%' }}
        {...props} 
      />
    </InputWrapper>
  );
};

DatePicker.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
};

export default DatePicker; 